<ng-container class="flex" >

        <div class="form-group product__option" >
            <div class="form-group">
                <mat-grid-list cols="4">
                    <mat-grid-tile></mat-grid-tile>
                    <mat-grid-tile>

                        <mat-calendar
                        [selected]="selectedDate"
                        [startAt]="startAt"
                        [minDate]="minDate"
                        [maxDate]="maxDate"
                        [dateFilter]="dateFilter"
                        (selectedChange)="onSelect($event)">
                        </mat-calendar>

                    </mat-grid-tile>
                    <mat-grid-tile>

                        <p class="cal_date">{{DayAndDate}}, {{year}}</p>

                    </mat-grid-tile>
                    <mat-grid-tile></mat-grid-tile>
                </mat-grid-list>
                  <p>Selected range: {{range.value | json}}</p>
            </div>
        </div>


</ng-container>


<!--  {{options.value | json}} -->
